module.exports = __webpack_public_path__ + "2026310:ef9a7edf554eddff21f3/img/info_image@1x.6f930c0.png";